/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Tools_Drawer_DescriptionInputs */



/**
* | output |
* | --- |
* | "Set every tool for this subject in one place. Inherited options fall back to the everyone value only — team grants or floors a user inherits are not reflecte..." |
*
* @param {Rights_Tools_Drawer_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_drawer_description = /** @type {((inputs?: Rights_Tools_Drawer_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_Drawer_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alle Tools für dieses Subjekt an einer Stelle festlegen. Geerbte Optionen fallen nur auf den „Alle“-Wert zurück – Team-Freigaben oder -Sperren, die ein Benutzer erbt, sind nicht berücksichtigt, der tatsächliche Zugriff kann daher abweichen.")
	return /** @type {LocalizedString} */ ("Set every tool for this subject in one place. Inherited options fall back to the everyone value only — team grants or floors a user inherits are not reflected, so effective access can differ.")
});